export default function Arrow() {
    return (
        <div className="flex items-center w-[84px] rotate-90 lg:w-[200px] xl:w-[333px] lg:rotate-0">
            <div className="h-px w-52 bg-[#555] bg-gradient-to-r from-[#abacc2] to-[#abacc200]"></div>
            <div className="w-0 h-0 border-l-8
            border-l-[#555] border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
        </div>)
}
